

// 在线问诊——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 12 }, (_, i) => ({
  path: `consultation/zfb/index${i + 1}`,
  name: `consultationZfbIndex${i + 1}`,
  component: () => import(`@/views/health/consultation/zfb/index${i + 1}.vue`)
}))

export default {
  path: '/health',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 在线问诊——支付宝，主流程
    ...zfbMainRoutes
  ]
}
